import React from "react";
import { Link } from "react-router-dom";
import cartimg from "../../assets/logo/icons8-cart-96.png";
import { baseUrl } from "../../utils/APi";
const MobileHeader = () => {
  return (
    <nav id="main-nav" className="main-nav">
      <ul id="menu-primary-menu" className="menu">
        <li className="menu-item current-menu-item">
          <Link to={"/"}>Home</Link>
        </li>
        <li className="menu-item">
          <Link to={"/about"}>About </Link>
        </li>
        <li className="menu-item menu-item-has-children">
          <Link>Events </Link>
          <ul className="sub-menu">
            <li className="menu-item">
              <Link to={"/events"}>Events </Link>
            </li>
            <li className="menu-item">
              <Link to={"/singleEvent"}>Single Event </Link>
            </li>
          </ul>
        </li>
        <li className="menu-item menu-item-has-children">
          <Link>Activities</Link>
          <ul className="sub-menu">
            <li className="menu-item">
              <Link to={"/Activites"}>Activities</Link>
            </li>
            <li className="menu-item">
              <Link to={"/SingleActivity"}> Single Activity</Link>
            </li>
          </ul>
        </li>
        <li className="menu-item">
          <Link to={"/team"}>Our Team</Link>
        </li>
        <li className="menu-item menu-item-has-children">
          <Link>Blog </Link>
          <ul className="sub-menu right-sub-menu">
            <li className="menu-item">
              <Link to={"/blog"}>Blog</Link>
            </li>
            <li className="menu-item">
              <Link to={"/singleBlog"}>Single Blog</Link>
            </li>
          </ul>
        </li>
        <li className="menu-item">
          <Link to={"/contact"}>Contact</Link>
        </li>
      </ul>
    </nav>
  );
};
export default MobileHeader;
